export const routes = [
  {
    name: "guide",
    icon: "fas fa-book",
    pages: [
      { name: "installation", label: null },
      { name: "license", label: null },
      { name: "what-is-tailwind-css", label: null },
    ],
  },
  {
    name: "Customization",
    icon: "fas fa-paint-brush",
    pages: [
      { name: "theming", label: null },
      { name: "colors", label: null },
      { name: "fonts", label: null },
      { name: "shadows", label: null },
      { name: "screens", label: null },
    ],
  },
  {
    name: "components",
    icon: "fas fa-shapes",
    pages: [
      {
        name: "accordion",
        label: null,
      },
      {
        name: "alert",
        label: null,
      },
      {
        name: "avatar",
        label: null,
      },
      {
        name: "breadcrumbs",
        label: null,
      },
      {
        name: "button",
        label: null,
      },
      {
        name: "card",
        label: null,
      },
      {
        name: "checkbox",
        label: null,
      },
      {
        name: "chip",
        label: null,
      },
      {
        name: "dialog",
        label: null,
      },
      {
        name: "icon-button",
        label: null,
      },
      {
        name: "input",
        label: null,
      },
      {
        name: "form",
        label: null,
      },
      {
        name: "menu",
        label: null,
      },
      {
        name: "navbar",
        label: null,
      },
      {
        name: "pagination",
        label: null,
      },
      {
        name: "popover",
        label: null,
      },
      {
        name: "progress-bar",
        label: null,
      },
      {
        name: "radio-button",
        label: null,
      },
      {
        name: "select",
        label: null,
      },
      {
        name: "switch",
        label: null,
      },
      {
        name: "tabs",
        label: null,
      },
      {
        name: "textarea",
        label: null,
      },
      {
        name: "tooltip",
        label: null,
      },
      {
        name: "typography",
        label: null,
      },
      {
        name: "footer",
        label: null,
      },
    ],
  },
];
